<template>
  <artmisads-modal :open="true"
    :title="props.modalData.id ? st('settingsCommissionRule.modalTitleEdit') : st('settingsCommissionRule.modalTitleAdd')"
    :width="720" :onCancel="() => props.setShowModal(false)" :destroyOnClose="true" :mask-closable="false">
    <a-spin :spinning="spinning">
      <div class="ruleModal">
        <div class="item">
          <a-form>
            <a-form-item name="ruleName" v-bind="validateInfos.ruleName">
              <div class="input-item">
                <span class="text">{{ st('settingsCommissionRule.fieldRuleName') }}<span>*</span></span>
                <artmisads-input :disabled="!!props.modalData.id" maxlength="100" style="width: 560px;"
                  @blur="() => validate('ruleName')" size="middle" v-model:value="modelRef.ruleName" />
              </div>
            </a-form-item>
          </a-form>
        </div>
        <div class="item">
          <a-form>
            <a-form-item name="commissionType" v-bind="validateInfos.commissionType">
              <div class="input-item" ref="specialCommissionRef">
                <span class="text">
                  {{ st('settingsCommissionRule.fieldRuleRateType') }}<span>*</span>
                  <a-popover :getPopupContainer="() => specialCommissionRef">
                    <template #content>
                      <p class="tooltip-text" v-if="props.activeTab === '0'">
                        {{ st('settingsCommissionRule.tooltipRateTypeAttributionIntro') }}<br />
                        {{ st('settingsCommissionRule.tooltipRateTypeAttributionOption1') }}<br />
                        {{ st('settingsCommissionRule.tooltipRateTypeAttributionOption2') }}
                      </p>
                      <p class="tooltip-text" v-if="props.activeTab === '1'">
                        {{ st('settingsCommissionRule.tooltipRateTypeAssociateIntro') }}<br />
                        {{ st('settingsCommissionRule.tooltipRateTypeAssociateOption1') }}<br />
                        {{ st('settingsCommissionRule.tooltipRateTypeAssociateOption2') }}
                      </p>
                    </template>
                    <svg class="wenhao-icon icon" aria-hidden="true">
                      <use xlink:href="#icon-wenhao-tianchong"></use>
                    </svg>
                  </a-popover>
                </span>
                <artmisads-select v-model:value="modelRef.commissionType" style="width: 560px;" size="middle"
                  :options="props.activeTab === '0' ? commissionRuleTypeOptions : associateCommissionRuleTypeOptions"
                  @blur="() => validate('commissionType')" :placeholder="$t('seller.common.select')" />
              </div>
            </a-form-item>
          </a-form>
        </div>
        <div class="item" v-if="modelRef.commissionType === 'RECALCULATE'">
          <a-form>
            <a-form-item name="commissionRate" v-bind="validateInfos.commissionRate">
              <div class="input-item">
                <span class="text">{{ st('settingsCommissionRule.fieldPublishersCommission') }}</span>
                <artmisads-input-number :min="0" :max="999" suffix="%" :step="1" size="large"
                  @blur="e => commissionBlur(e, 999)" v-model:value="modelRef.commissionRate"
                  @change="handleChangeCommission($event)" :placeholder="$t('seller.common.enterCommissionRange')" />
              </div>
            </a-form-item>
          </a-form>
          <p class="note">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-info"></use>
            </svg>
            {{ st('settingsCommissionRule.noteRecalculateExample') }}
          </p>
        </div>
        <div class="item-commission" v-else-if="modelRef.commissionType === 'NEW_COMMISSION'">
          <div class="commission-input">
            <span>{{ st('settingsCommissionRule.fieldPublisherCommission') }}</span>
            <artmisads-input-number @blur="e => commissionBlur(e, 99)" :min="0" :max="100" suffix="%" :step="0.5"
              size="large" :placeholder="$t('seller.common.pleaseEnter')" v-model:value="modelRef.commissionRate"
              @change="handleChangeCommission($event)" />
          </div>
          <span>+</span>
          <div class="fees">
            <span>{{ st('settingsCommissionRule.fieldArtemisAdsFees') }}<a-tooltip
                :getPopupContainer="() => $refs.setCommissionRef">
                <template #title>{{ st('settingsCommissionRule.feesTooltip') }}</template>
                <Icon name="wenhao-tianchong" class="question-icon" />
              </a-tooltip></span>
            <artmisads-button disabled>{{ fees.toFixed(1) }}%</artmisads-button>
          </div>
          <span>=</span>
          <div class="total">
            <span>{{ st('settingsCommissionRule.fieldTotal') }}</span>
            <artmisads-button disabled>
              <span>{{
                modelRef.commissionRate
                  ? parseFloat(Number(fees) + Number(modelRef.commissionRate)).toFixed(1)
                  : Number(fees).toFixed(1)
              }}</span>
              <span>%</span>
            </artmisads-button>
          </div>
        </div>
        <div class="item">
          <a-form>
            <a-form-item name="publisherVOList" v-bind="validateInfos.publisherVOList">
              <div class="input-item" ref="setPublisherRef">
                <span class="text">{{ st('settingsCommissionRule.fieldPublishers') }}<span>*</span></span>
                <div class="select-container">
                  <artmisads-select :getPopupContainer="() => $refs.setPublisherRef" :not-found-content="null"
                    show-search mode="multiple" v-model:value="modelRef.publisherVOList" style="width: 560px"
                    :options="publisherOptions" @search="searchPublisher" :show-arrow="false" :filter-option="false"
                    allowClear @change="onChangePublisher" @blur="() => validate('publisherVOList')">

                  </artmisads-select>
                  <artmisads-button v-if="props.activeTab == '1'" type="primary" size="small"
                    @click="openPublisherModal">{{
                      st('settingsCommissionRule.btnSelect') }}</artmisads-button>
                </div>

                <!-- <artmisads-select size="large" style="width: 560px;" v-model:value="modelRef.publisherVOList" mode="multiple" :options="categories"/> -->
              </div>
            </a-form-item>
          </a-form>
          <!-- <p class="note">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-info"></use>
            </svg>
            You can add up to 10 publishers by searching for their names.
          </p> -->
        </div>
        <div class="item" v-if="String(props.activeTab) === '0'">
          <a-form>
            <a-form-item name="brandIdsVOList" v-bind="validateInfos.brandIdsVOList">
              <div class="input-item" ref="setBrandRef">
                <span class="text">{{ st('settingsCommissionRule.fieldConditionsBrand') }}</span>
                <artmisads-select :getPopupContainer="() => $refs.setBrandRef" show-search mode="multiple"
                  v-model:value="modelRef.brandIdsVOList" style="width: 560px" :options="brandOptions"
                  @search="searchBrand" :show-arrow="false" :filter-option="false" :not-found-content="null" allowClear
                  @change="onChangeBrandIds" @blur="() => validate('brandIdsVOList')" />
                <!-- @blur="() => validate('brandIdsVOList')" -->

              </div>
            </a-form-item>
          </a-form>
          <p class="note">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-info"></use>
            </svg>
            {{ st('settingsCommissionRule.noteBrandDefault') }}
          </p>
        </div>
        <div class="item">
          <a-form>
            <a-form-item name="asinIdsVOList" v-bind="validateInfos.asinIdsVOList">
              <div class="input-item" ref="setAsinRef">
                <span class="text">{{ props.activeTab === '0' ? st('settingsCommissionRule.fieldConditionsAsin') :
                  st('settingsCommissionRule.fieldAsin') }}</span>
                <div class="select-container">
                  <artmisads-select :getPopupContainer="() => $refs.setAsinRef" show-search mode="multiple"
                    v-model:value="modelRef.asinIdsVOList" style="width: 560px" :options="asinOptions"
                    @search="searchAsin" :show-arrow="false" :filter-option="false" :not-found-content="null" allowClear
                    @change="onChangeAsinIds" @blur="() => validate('asinIdsVOList')" />
                  <artmisads-button v-if="props.activeTab == '1'" type="primary" size="small" @click="openAsinModal">{{
                    st('settingsCommissionRule.btnUpload') }}</artmisads-button>
                </div>

              </div>
            </a-form-item>
          </a-form>

          <p class="note">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-info"></use>
            </svg>
            {{ st('settingsCommissionRule.noteAsinDefault') }}
          </p>
        </div>
        <div class="item">
          <div class="input-item">
            <span class="text">{{ st('settingsCommissionRule.fieldIncludeVariations') }}</span>
            <a-switch style="width: 40px;margin-top: 5px;" v-model:checked="modelRef.includeVariations"
              :disabled="!hasAsinSelected" />
          </div>
          <p class="note">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-info"></use>
            </svg>
            {{ st('settingsCommissionRule.noteIncludeVariations') }}
          </p>
        </div>
        <div class="item">
          <div class="input-item">
            <span class="text">{{ st('settingsCommissionRule.fieldDateRange') }}<span>*</span></span>
            <div class="date-item">
              <a-form>
                <a-form-item name="startDate" v-bind="validateInfos.startDate">
                  <artemisads-date-picker :disabled="!!props.modalData.id" style="width: 270px"
                    v-model:value="modelRef.startDate" :allowClear="false" :disabled-date="disabledStartDate"
                    @change="onChangeStartDate" @blur="() => validate('startDate')" />
                </a-form-item>
              </a-form>
              <a-form>
                <a-form-item name="endDate" v-bind="validateInfos.endDate">
                  <artemisads-date-picker v-model:value="modelRef.endDate" disabledEndDate :allowClear="false"
                    :disabled-date="disabledEndDate" @blur="() => validate('endDate')" style="width: 270px" />
                </a-form-item>
              </a-form>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
    <template #footer>
      <div class="ruleModal-btn">
        <span class="operation-btn">
          <a-popconfirm :title="st('settingsCommissionRule.confirmStopRule')" :ok-text="st('common.confirm')"
            :cancel-text="st('common.cancel')" @confirm="onExpire" :overlayInnerStyle="{ padding: '16px' }">
            <span class="to-expire" v-if="props.modalData.status === 'Active'">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-error3"></use>
              </svg>
              {{ st('settingsCommissionRule.btnExpire') }}
            </span>
          </a-popconfirm>
          <a-popconfirm :title="st('settingsCommissionRule.confirmDeleteRule')" :ok-text="st('common.confirm')"
            :cancel-text="st('common.cancel')" @confirm="onDelete" :overlayInnerStyle="{ padding: '16px' }">
            <span class="to-delete" v-if="props.modalData.status === 'Scheduled'">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-lajitong"></use>
              </svg>
              {{ st('settingsCommissionRule.btnDelete') }}
            </span>
          </a-popconfirm>
        </span>
        <div class="ok-cancel-btn">
          <artmisads-button @click="() => setShowModal()">{{ st('common.cancel') }}</artmisads-button>
          <artmisads-button type="primary" @click="sellerSettingsCommissionRuleUpdate">{{ st('common.save')
            }}</artmisads-button>
        </div>
      </div>
    </template>
    <publishModal ref="publishModalRef" @submit="handleSubmit" />
    <uploadModal :showUpdateProductDealsModal="showUpdateProductDealsModal" :dataList="dataList"
      :setDataList="setDataList" ref="uploadModalRef" />
  </artmisads-modal>
</template>

<script setup>
import moment from 'moment'
import { Form, message } from 'ant-design-vue'
import { ref, reactive, onMounted, computed } from "vue"
import { connectionApi } from "@/server/seller/index"
import { brandApi, productsApi } from '@/server/index'
import { useSellerI18n } from '@/composables/useSellerI18n'
import { useSellerBrandStore } from '@/storeData/sellerbrand'
import { countBrandNames } from '~/utils'
import publishModal from './publishModal.vue'
import uploadModal from './uploadModal.vue'
const { st } = useSellerI18n()
const publishModalRef = ref(null)
const uploadModalRef = ref(null)

const commissionRuleTypeOptions = computed(() => [
  {
    label: st('settingsCommissionRule.rateTypeNewCommissionAttribution'),
    value: 'NEW_COMMISSION',
  },
  {
    label: st('settingsCommissionRule.rateTypeRecalculate'),
    value: 'RECALCULATE',
  },
])

const associateCommissionRuleTypeOptions = computed(() => [
  {
    label: st('settingsCommissionRule.rateTypeNewCommissionAssociate'),
    value: 'NEW_COMMISSION',
  },
  {
    label: st('settingsCommissionRule.rateTypeBlacklist'),
    value: 'BLACKLIST',
  },
])

const brandStore = useSellerBrandStore()
const dataList = ref({ successList: [], failList: [] })
const props = defineProps(["modalData", 'setShowModal', 'countryList', 'defaultCommission', 'activeTab'])
let amazonUserId
const specialCommissionRef = ref()
const showUpdateProductDealsModal = ref(false)
const spinning = ref(false)
const publisherOptions = ref([])
const brandOptions = ref([])
const asinOptions = ref([])
const publisherLoading = ref(false)
const ConditionsBrandLoading = ref(false)
const ConditionsASINLoading = ref(false)
const useForm = Form.useForm
const modelRef = reactive({
  ruleName: props.modalData.ruleName || '',
  commissionType: props.modalData.commissionType || null,
  publisherVOList: props.modalData.publisherVOList ? props?.modalData?.publisherVOList?.map(item => {
    item.value = item.id
    item.label = item.creatorName
    return item
  }) : [],
  commissionRate: props.modalData.commissionRate ?? '',
  asinIdsVOList: props.modalData.productInfoList ? props?.modalData?.productInfoList?.map(item => {
    item.value = item.id
    item.label = item.asin
    return item
  }) : [],
  brandIdsVOList: props.modalData.brandInfoList ? props?.modalData?.brandInfoList?.map(item => {
    item.value = item.id
    item.label = item.brandName
    return item
  }) : [],
  startDate: props.modalData.startDate ? moment(props.modalData.startDate) : moment().add(1, 'day'),
  endDate: props.modalData.startDate ? moment(props.modalData.endDate) : moment().add(31, 'day'),
  includeVariations: Boolean(
    props.modalData.includeVariations ??
    props.modalData.includeVariation ??
    props.modalData.isIncludeVariations,
  ) && !!(props.modalData.productInfoList?.length),
})
const hasAsinSelected = computed(() => modelRef.asinIdsVOList?.length > 0)
const setDataList = (data) => {
  const list = data?.map(item => {
    item.value = item.id
    item.label = item.asin
    return item
  })
  // 去重处理，根据id属性判断重复项
  const existingIds = new Set(modelRef.asinIdsVOList.map(item => item.id))
  const newItems = list.filter(item => !existingIds.has(item.id))
  modelRef.asinIdsVOList = [...modelRef.asinIdsVOList, ...newItems]
}
const handleSubmit = (data) => {
  const list = data?.map(item => {
    item.value = item.id
    item.label = item.creatorName
    return item
  })
  // 去重处理，根据id属性判断重复项
  const existingIds = new Set(modelRef.publisherVOList.map(item => item.id))
  const newItems = list.filter(item => !existingIds.has(item.id))
  modelRef.publisherVOList = [...modelRef.publisherVOList, ...newItems]
}
const rulesRef = computed(() => ({
  ruleName: [{
    required: true,
    message: st('settingsCommissionRule.validationRuleName'),
    trigger: ['blur'],
  }],
  publisherVOList: [{
    required: true,
    message: st('settingsCommissionRule.validationPublishers'),
    trigger: ['blur'],
  }],
  brandIdsVOList: [{
    required: false,
    trigger: ['blur'],
  }],
  asinIdsVOList: [{
    required: false,
    trigger: ['blur'],
  }],
  commissionType: [{
    required: true,
    message: st('settingsCommissionRule.validationCommissionType'),
    trigger: ['blur'],
  }],
  startDate: [{
    required: true,
    message: st('settingsCommissionRule.validationStartDate'),
    trigger: ['blur'],
  }],
  endDate: [{
    required: true,
    message: st('settingsCommissionRule.validationEndDate'),
    trigger: ['blur'],
  }],
  commissionRate: [{
    required: true,
    message: st('settingsCommissionRule.validationCommissionRate'),
    trigger: ['blur'],
  }],
}))

const { validate, validateInfos } = useForm(modelRef, rulesRef)

const disabledStartDate = current => {
  return current && current < moment().add(1, 'day')
}

const disabledEndDate = current => {
  return current && (current < modelRef.startDate || moment().add(1, 'day') > current)
}
const openPublisherModal = () => {
  publishModalRef.value.open()
}
const openAsinModal = () => {
  uploadModalRef.value.openModal()
  // asinModalRef.value.open()
}

const commissionBlur = (e, max) => {
  validate('commissionRate')
  const newValue = e.target.value
    .replace(/[^0-9.]/g, '')
    .split('.')
    .map((v, i) => {
      v = v ? parseInt(v) : null
      if (i && v) {
        v = 5
      }
      return v
    })
    .join('.')
  let data = Number(newValue)
  data = data > max ? max : data
  if (max === 999) {
    data = Math.floor(data)
  }
  modelRef.commissionRate = data
}

const onChangeStartDate = data => {
  modelRef.endDate = moment(data.valueOf()).add(1, 'day')
}

const fees = computed(() => {
  let value = 0
  if (props.activeTab == 0) {
    if (props.defaultCommission.platformType === 'multiply') {
      if (modelRef.commissionRate) {
        value = (modelRef.commissionRate * props.defaultCommission.platformFeeFactor) / 100
      } else {
        value =
          (props.defaultCommission.defaultCommissionRate *
            props.defaultCommission.platformFeeFactor) /
          100
        if (modelRef.commissionRate == 0) {
          value =
            (modelRef.commissionRate * props.defaultCommission.platformFeeFactor) / 100
        }
      }
    } else {
      value = props.defaultCommission.platformFeeFactor
    }
    if (props.defaultCommission.platformType === 'multiply') {
      if (value >= props.defaultCommission.platformMaxFeeRate) {
        value = props.defaultCommission.platformMaxFeeRate
      }
    } else {
      if (value >= props.defaultCommission.platformFeeFactor) {
        value = props.defaultCommission.platformFeeFactor
      }
    }
  } else {
    value = props.defaultCommission.platformFeeFactor
  }
  let arr = value && value.toString().split('.')
  let firstNumber = arr && Number(arr[0])
  let middleNum = '0'
  if (arr && arr.length > 1) {
    middleNum = Number(arr[1][0])
    if (arr[1][1] == 5) {
      if (arr[1][0] % 2 !== 0) {
        middleNum += 1
        if (arr[1][0] == 9) {
          middleNum = 0
          firstNumber += 1
        }
      }
    } else if (arr[1][1] > 5) {
      middleNum += 1
      if (arr[1][0] == 9) {
        middleNum = 0
        firstNumber += 1
      }
    }
  }
  let endNum = arr && parseFloat(firstNumber + '.' + middleNum)
  return endNum
})

const sellerSettingsCommissionRuleUpdate = async () => {

  if (props.activeTab == 1) {
    modelRef.brandIdsVOList = ['123']
    if (modelRef.commissionType == 'BLACKLIST') {
      modelRef.commissionRate = 0
    }
  }
  const validateRes = await validate()
  if (!validateRes.errorFields) {
    spinning.value = true
    let paramsData = validateRes, res
    // console.log(paramsData,'paramsData');
    // return  


    paramsData.includeVariation = modelRef.includeVariations
    paramsData.startDate = paramsData?.startDate.format('YYYY-MM-DD')
    paramsData.endDate = paramsData?.endDate.format('YYYY-MM-DD')
    paramsData.publisherIds = paramsData?.publisherVOList?.map(item => item.value || item)
    if (props.activeTab == '0') {
      paramsData.brandIds = paramsData?.brandIdsVOList?.map(item => item.value || item)
    }
    paramsData.productIds = paramsData?.asinIdsVOList?.map(item => item.value || item)
    delete paramsData.publisherVOList
    delete paramsData.brandIdsVOList
    delete paramsData.asinIdsVOList
    if (props.activeTab === '0') {
      paramsData.businessType = 'Attribution'
    } else {
      paramsData.businessType = 'Associate'
    }
    if (props.modalData.id) {
      paramsData.id = props.modalData.id
      res = await connectionApi.sellerSettingsCommissionRuleUpdate(paramsData)
    } else {
      res = await connectionApi.sellerSettingsCommissionRuleCreate(paramsData)
    }
    const { success, code, error } = res
    if (success) {
      props.setShowModal(false, true)
    } else {
      if (code === '1400') {
        message.warning(st('settingsCommissionRule.errRuleNameExists'))
      }
      else {
        message.error(error)
      }
    }
    spinning.value = false
  }
}

const handleChangeCommission = (e) => {
  modelRef.commissionRate = e
}

const onChangePublisher = data => {
  // modelRef.publisherVOList = data.splice(0, 10);
}
const onChangeBrandIds = data => {

  // modelRef.brandIdsVOList = data.splice(0, 10);
}
const onChangeAsinIds = data => {
  modelRef.asinIdsVOList = data
  if (!modelRef.asinIdsVOList.length) {
    modelRef.includeVariations = false
  }
}
const onDelete = async () => {
  spinning.value = true
  let paramsData = { id: props.modalData.id }
  const res = await await connectionApi.sellerSettingsCommissionRuleDelete(paramsData)
  const { success } = res
  if (success) {
    props.setShowModal(false, true)
  }
  spinning.value = false
}

const onExpire = async () => {
  spinning.value = true
  let paramsData = { id: props.modalData.id }
  const res = await await connectionApi.sellerSettingsCommissionRuleExpire(paramsData)
  const { success } = res
  if (success) {
    props.setShowModal(false, true)
  }
  spinning.value = false
}

const searchPublisher = async name => {
  publisherLoading.value = true
  let res, paramsData = {
    name,
    ruId: props.modalData.id || '',
    endDate: modelRef.endDate.format('YYYY-MM-DD'),
    startDate: modelRef.startDate.format('YYYY-MM-DD'),
    businessType: props.activeTab === '0' ? 'ATTRIBUTION' : 'ASSOCIATE'
  }
  res = await connectionApi.getSellerSettingsCommissionRuleSearchPublisher(paramsData)
  if (res && res.data) {
    publisherOptions.value = res.data?.map(item => {
      item.value = item.id
      item.label = item.creatorName
      return item
    })
  }
  publisherLoading.value = false
}
const getAttributionBrandList = (name) => {
  ConditionsBrandLoading.value = true
  amazonUserId = brandStore?.params?.amazonUserId
  let _params = {
    keyword: name,
    page: 1,
    size: 999,
    amazonUserId: amazonUserId
  }
  brandApi.getPartSellerBrands(_params).then(res => {
    if (res && res.data?.data) {
      const brandNameCount = countBrandNames(res.data?.data, 'amazonBrandName')
      brandOptions.value = res.data?.data?.map(item => {
        item.value = item.id
        item.label = `${item.amazonBrandName}${brandNameCount[item.amazonBrandName] > 1 ? `(${item.amazonProfileAccountInfoName})` : ''}`
        return item
      })
    }
  }).finally(() => {
    ConditionsBrandLoading.value = false
  })
}
const getAttributionAsinList = async (name) => {
  ConditionsASINLoading.value = true
  let newParams = {
    title: name,
    page: 1,
    size: 100,
  }
  const res = await productsApi.getProductList(newParams)
  const { success, data } = res
  if (success) {
    asinOptions.value = data.data?.map(item => {
      item.value = item.id
      item.label = item.asin
      return item
    })
  }
  ConditionsASINLoading.value = false
}
const getAssociateAsinList = async (name) => {
  ConditionsASINLoading.value = true
  let newParams = {
    title: name,
    page: 1,
    size: 500,
  }
  const res = await productsApi.getAssociateProductList(newParams)
  const { success, data } = res
  if (success) {
    asinOptions.value = data.data?.map(item => {
      item.value = item.id
      item.label = item.asin
      return item
    })
  }
  ConditionsASINLoading.value = false
}
const searchBrand = async name => {

  if (props.activeTab === '0') {
    getAttributionBrandList(name)
  }

}
const searchAsin = async name => {



  if (props.activeTab === '0') {
    getAttributionAsinList(name)

  } else {
    getAssociateAsinList(name)
  }

}
</script>

<style lang="less" scoped>
.ruleModal {
  padding-bottom: 3px;

  .item {
    display: flex;
    flex-direction: column;
    margin-top: 24px;

    &:first-child {
      margin-top: 8px;
    }

    .date-item {
      display: flex;
      justify-content: space-between;
    }

    .note {
      display: flex;
      height: 18px;
      line-height: 18px;
      color: var(--dark-3);
      font-weight: 400;
      font-size: 12px;
      letter-spacing: 0.3px;
      border-radius: 8px;
      margin-top: 6px;

      svg {
        width: 16px;
        height: 16px;
        fill: var(--dark-3);
        margin-right: 4px;
        align-self: center;
      }
    }

    .wenhao-icon {
      width: 16px;
      height: 16px;
      margin-left: 2px;
      fill: var(--bg-gray-7);

      &:focus {
        outline: none;
      }
    }

    :deep(.ant-form) {
      .input-item {
        display: flex;
        flex-direction: column;
        // width: 560px;

        .select-container {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .text {
          color: var(--dark-2);
          font-weight: 500;
          line-height: 18px;
          font-size: 13px;
          margin-bottom: 4px;
          display: flex;

          >span {
            color: var(--red-text);
            margin-left: 3px;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
          }
        }
      }

      .ant-form-item {
        margin-bottom: 0;
      }
    }
  }

  .input-item {
    display: flex;
    flex-direction: column;
    width: 560px;

    :deep(.ant-popover) {
      width: 500px;

      .tooltip-text {
        padding: 16px;
      }
    }

    .text {
      color: var(--dark-2);
      font-weight: 500;
      line-height: 18px;
      font-size: 13px;
      margin-bottom: 4px;
      display: flex;

      >span {
        color: var(--red-text);
        margin-left: 3px;
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
      }
    }
  }

  .item-commission {
    display: flex;
    margin-top: 24px;

    >span {
      align-self: center;
      margin: 20px 10px 0 10px;
      font-family: Sora, sans-serif;
      font-weight: 500;
      color: #0f0629;
    }

    .fees,
    .total,
    .commission-input {
      display: flex;
      flex-direction: column;

      >span {
        margin-bottom: 6px;
        font-weight: 500;
        color: var(--dark-2);
        line-height: 19px;
        font-size: 13px;
      }
    }

    .commission-input {
      position: relative;

      .defalut-text {
        position: absolute;
        font-family: Sora, sans-serif;
        color: var(--dark-4);
        line-height: 20px;
        left: 15px;
        top: 34px;
        margin: 0;
      }

      .haifenhao {
        position: absolute;
        font-weight: 500;
        font-size: var(--font-size-large);
        color: var(--dark-1);
        right: 30px;
        top: 34px;
        margin: 0;
      }

      :deep(.ant-input-number) {
        width: 200px;

        .ant-input-number-handler-wrap {
          opacity: 1;
        }
      }
    }

    .total {
      >button {
        width: 96px;
        display: flex;
        justify-content: space-between;

        >span {
          align-self: center;
        }
      }
    }

    .fees {
      >button {
        width: 144px;
      }

      .question-icon {
        margin-left: 3px;
        color: var(--yellow-4);
      }
    }

    .fees,
    .total {
      >button {
        padding-left: 12px;
        text-align: left;
        border-radius: 8px;
        font-weight: 500;
        font-size: var(--font-size-large);
        color: var(--dark-1);
      }
    }
  }
}

.ruleModal-btn {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .operation-btn {
    display: flex;
    font-weight: 400;
    font-size: 13px;
    color: var(--red-text);
    letter-spacing: 0.3px;
    line-height: 20px;

    >span {
      display: flex;
      align-self: center;
      cursor: pointer;

      svg {
        width: 16px;
        height: 16px;
        margin-right: 4px;
        align-self: center;
      }
    }
  }
}
</style>
